export default __webpack_public_path__ + "img/pin_icons/air_compressor_b.svg";